<template>
  <div>
  </div>
</template>

<script>
  import Picker from 'better-picker'

  export default {
    name: 'xk-datePickerMod',
    props: ['title', 'delayed'],
    data () {
      return {
        state: false,
        picker: null,
        day: [],
        hour: [],
        minute: [],
        clickState: true
      }
    },
    methods: {
      showFn: function () { // 插件显示
        this.picker.show(() => {
          this.picker.scrollColumn(0, 0)
          if (this.delayed) {
            this.picker.scrollColumn(1, 0)
          } else {
            this.picker.scrollColumn(1, 1)
          }
          this.picker.scrollColumn(2, 0)
        })
      },
      getCurrentMonthLast: function (date) { // 获取本月最后一天
        let currentMonth = date.getMonth()
        let nextMonth = ++currentMonth
        let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
        let oneDay = 1000 * 60 * 60 * 24
        return new Date(nextMonthFirstDay - oneDay).getDate()
      }
    },
    mounted: function () {
      let that = this
      let delayed = this.delayed ? this.delayed * 60 * 1000 : 0
      let nowDate = new Date()
      if (delayed) {
        nowDate = new Date(nowDate.valueOf() + delayed)
      }
      let nowYear = Number(nowDate.getFullYear())
      let nowMonth = Number(nowDate.getMonth())
      let nowDay = Number(nowDate.getDate())
      let nowHour = Number(nowDate.getHours())
      let nowMinute = Number(nowDate.getMinutes())
      console.log('nowDay', nowDay)
      console.log('nowHour', nowHour)
      console.log('nowMinute', nowMinute)
      that.day = []
      let dayNum = 0
      that.hour = []
      let hourNum = -1
      if (delayed) {
        hourNum = 0
      }
      that.minute = []
      let minuteNum = 0

      function dayFn (nowDay) {
        let countDay = nowDay + dayNum
        let dayText = ''
        let dayVal = ''
        if (dayNum === 0) {
          dayText = '今天'
        }
        if (dayNum === 1) {
          dayText = '明天'
        }
        if (dayNum === 2) {
          dayText = '后天'
        }
        if (countDay <= that.getCurrentMonthLast(nowDate)) {
          dayVal = nowYear + ',' + (nowMonth + 1) + ',' + countDay
        } else {
          let countMonth = nowMonth + 2
          if (countMonth <= 11) {
            dayVal = nowYear + ',' + countMonth + ',' + (countDay - that.getCurrentMonthLast(nowDate))
          } else {
            dayVal = (Number(nowYear) + 1) + ',' + (countMonth - nowMonth) + ',' + (countDay - that.getCurrentMonthLast(nowDate))
          }
        }
        that.day.push({
          text: dayText,
          value: dayVal
        })
        dayNum++
        if (dayNum > 2) {
          return false
        }
        dayFn(nowDay)
      }

      dayFn(nowDay)

      function hourFn (nowHour) {
        let countHour = nowHour + hourNum
        let dayText = ''
        let dayVal = ''
        if (hourNum === -1 && !delayed) {
          dayText = '现在'
          dayVal = nowHour + ',' + nowMinute
        } else {
          dayText = countHour < 10 ? '0' + countHour : countHour
          dayVal = countHour < 10 ? '0' + countHour : countHour
        }
        hourNum++
        that.hour.push({
          text: dayText,
          value: dayVal
        })
        if (countHour >= 23) {
          return false
        }
        hourFn(nowHour)
      }

      hourFn(nowHour)

      function minuteFn (nowMinute) {
        let countMinute = minuteNum * 10
        if (nowMinute > 50) {
          that.hour = []
          if (delayed) {
            hourNum = 0
          } else {
            hourNum = -1
          }
          hourFn(nowHour + 1)
          that.minute = []
          minuteNum = 0
          minuteFn(0)
          return
        }
        if ((countMinute - nowMinute) >= 0 && (countMinute - nowMinute) <= 10) {
          for (let i = countMinute; i < 60; i += 10) {
            that.minute.push({
              text: i < 10 ? '0' + i : i,
              value: i
            })
          }
          return true
        }
        minuteNum++
        if (minuteNum > 5) {
          return false
        }
        minuteFn(nowMinute)
      }

      minuteFn(nowMinute)

      let picker = new Picker({
        data: [that.day, that.hour, that.minute],
        selectedIndex: [0, 1, 2],
        title: that.$props.title
      })
      that.picker = picker
      let firstListIndex = 0
      picker.on('picker.change', (index, selectedIndex) => {
        console.log(index, selectedIndex, firstListIndex)
        if (index === 0) {
          firstListIndex = selectedIndex
          if (selectedIndex > 0) {
            hourNum = 0
            minuteNum = 0
            that.hour = []
            that.minute = []
            hourFn(0)
            minuteFn(0)
            picker.refillColumn(1, that.hour)
            picker.refillColumn(2, that.minute)
          } else {
            hourNum = 0 - 1
            minuteNum = 0
            that.hour = []
            that.minute = []
            hourFn(nowHour)
            minuteFn(nowMinute)
            console.log('selectedIndex<0', index, selectedIndex, that.hour, that.minute)
            picker.refillColumn(1, that.hour)
            picker.refillColumn(2, that.minute)
          }
        }
        if (index === 1) {
          if (firstListIndex === 0 && selectedIndex === 0) {
            if (delayed) {
              minuteNum = 0
              that.minute = []
              minuteFn(nowMinute)
              picker.refillColumn(2, that.minute)
            } else {
              that.minute = []
              picker.refillColumn(2, that.minute)
            }
          }
          if (firstListIndex > 0 && selectedIndex === 0) {
            minuteNum = 0
            that.minute = []
            minuteFn(0)
            picker.refillColumn(2, that.minute)
          }
          if (selectedIndex === 1) {
            if (!delayed) {
              minuteNum = 0
              that.minute = []
              minuteFn(nowMinute)
              picker.refillColumn(2, that.minute)
            } else {
              minuteNum = 0
              that.minute = []
              minuteFn(0)
              picker.refillColumn(2, that.minute)
            }
          }
          if (selectedIndex > 1) {
            minuteNum = 0
            that.minute = []
            minuteFn(0)
            picker.refillColumn(2, that.minute)
          }
        }
      })
      picker.on('picker.select', (index, selectedIndex) => {
        if (that.clickState) {
          let name = ''
          let val = ''
          for (let i = 0; i < index.length; i++) {
            if (index[i] || index[i] === 0) {
              if (i === 0) {
                name = name + index[i].replace(',', '-').replace(',', '-') + ' '
              }
              if (i === 1) {
                name = name + (index[2] >= 0 ? index[i] + ':' : index[i].replace(',', ':'))
              }
              if (i === 2) {
                name = name + (index[i] < 10 ? '0' + index[i] : index[i])
              }
            }
          }
          if (selectedIndex[0] === 0 && selectedIndex[1] === 0 && !delayed) {
            name = '现在出发'
          }

          let year = ''
          let month = ''
          let day = ''
          let hour = ''
          let minute = ''
          if (that.day.length > 0 && that.hour.length > 0 && that.minute.length > 0) {
            year = that.day[selectedIndex[0]].value.split(',')[0]
            month = that.day[selectedIndex[0]].value.split(',')[1]
            day = that.day[selectedIndex[0]].value.split(',')[2]
            hour = that.hour[selectedIndex[1]].value
            minute = that.minute[selectedIndex[2]].value
            val = Date.parse(new Date(year, (month - 1), day, hour, minute, 0))
          } else {
            year = that.day[selectedIndex[0]].value.split(',')[0]
            month = that.day[selectedIndex[0]].value.split(',')[1]
            day = that.day[selectedIndex[0]].value.split(',')[2]
            hour = that.hour[selectedIndex[1]].value.split(',')[0]
            minute = that.hour[selectedIndex[1]].value.split(',')[1]
            val = Date.parse(new Date(year, (month - 1), day, hour, minute, 0))
          }

          let obj = {
            name: name,
            val: val
          }
          this.$emit('click', obj)
          document.getElementsByClassName('picker')[0].remove()
        }
      })
      picker.on('picker.cancel', () => {
        document.getElementsByClassName('picker')[0].remove()
        this.$emit('click')
      })
      that.showFn()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .picker .picker-panel .picker-choose .confirm {
    color: #f06553 !important;
  }
</style>



// WEBPACK FOOTER //
// datePickerMod.vue?2295b6b2